export default __webpack_public_path__ + "static/media/chiran_tonmoy.c90680f3.jpeg";